'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _editEnquiryExtraTemplate = require('../templates/enquiry/editEnquiryExtraTemplate.html');

var _editEnquiryExtraTemplate2 = _interopRequireDefault(_editEnquiryExtraTemplate);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddEditEnquiryExtra = function () {
  function AddEditEnquiryExtra($uibModal, $rootScope, authService, enquiryExtraManagementService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AddEditEnquiryExtra);
    this.$scope = $rootScope.$new();
    this.$uibModal = $uibModal;
    this.authService = authService;
    this.enquiryExtraManagementService = enquiryExtraManagementService;

    this.$scope.save = this.save;
    this.$scope.add = this.add;
    this.$scope.edit = this.edit;
    this.$scope.closeModal = this.closeModal;
    this.$scope.validateForm = this.validateForm;

    this.$scope.authService = authService;
    this.$scope.enquiryExtraManagementService = enquiryExtraManagementService;
  }

  (0, _createClass3.default)(AddEditEnquiryExtra, [{
    key: 'showAdd',
    value: function showAdd(enquiryExtraLookups, callback, fromEnquiry, complimentary) {
      this.$scope.enquiryExtraLookups = enquiryExtraLookups;
      this.$scope.callback = callback;
      this.$scope.errMsg = "";

      if (fromEnquiry) {
        this.$scope.add = this.addEnquiryOnly;
      } else {
        this.$scope.add = this.add;
      }

      this.$scope.tempExtra = {
        complimentary: complimentary,
        reportable: false
      };

      this.$scope.modalInstance = this.$uibModal.open({
        template: _editEnquiryExtraTemplate2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'showEdit',
    value: function showEdit(enquiryExtraLookups, extra, callback) {
      this.$scope.enquiryExtraLookups = enquiryExtraLookups;
      this.$scope.callback = callback;
      this.$scope.errMsg = "";
      this.$scope.tempExtra = extra;

      this.$scope.modalInstance = this.$uibModal.open({
        template: _editEnquiryExtraTemplate2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      var scope = this;

      if (scope.modalInstance) {
        scope.modalInstance.close();
      }
    }
  }, {
    key: 'save',
    value: function save() {
      var scope = this;

      if (!scope.validateForm(scope.tempExtra.enquiryExtraId)) {
        return;
      }

      if (!scope.tempExtra.enquiryExtraId) {
        scope.add();
      } else {
        scope.edit();
      }
    }
  }, {
    key: 'add',
    value: function add() {
      var scope = this;

      scope.enquiryExtraManagementService.addEnquiryExtra(scope.authService.authData.currentLocation.key, scope.tempExtra).then(function (response) {
        if (scope.callback) {
          scope.callback({
            enquiryExtraId: response.data,
            name: scope.tempExtra.name,
            defaultPrice: scope.tempExtra.defaultPrice,
            reportable: scope.tempExtra.reportable
          });
        }
      }).finally(function () {
        scope.closeModal();
      });
    }
  }, {
    key: 'addEnquiryOnly',
    value: function addEnquiryOnly() {
      var scope = this;

      if (scope.callback) {
        scope.callback({
          name: scope.tempExtra.name,
          defaultPrice: scope.tempExtra.defaultPrice,
          reportable: scope.tempExtra.reportable
        });
      }

      scope.closeModal();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var scope = this;

      scope.enquiryExtraManagementService.editEnquiryExtra(scope.authService.authData.currentLocation.key, scope.tempExtra.enquiryExtraId, scope.tempExtra).then(function (response) {
        if (scope.callback) {
          scope.callback({
            id: response.data,
            name: scope.tempExtra.name,
            defaultPrice: scope.tempExtra.defaultPrice,
            reportable: scope.tempExtra.reportable
          });
        }
      }).finally(function () {
        scope.closeModal();
      });
    }
  }, {
    key: 'validateForm',
    value: function validateForm(enquiryExtraId) {
      var scope = this;

      if (!scope.tempExtra.name || scope.tempExtra.name < 3 || scope.tempExtra.name > 40) {
        scope.errMsg = 'Name is required field and must be between 3 and 40 characters';
        return false;
      } else if ((0, _lodash.find)(scope.enquiryExtraLookups, function (e) {
        var removeEdit = false;
        if (enquiryExtraId) {
          removeEdit = e.enquiryExtraId !== enquiryExtraId;
        }

        return e.name.toLowerCase() === scope.tempExtra.name.toLowerCase() && removeEdit;
      })) {
        scope.errMsg = scope.tempExtra.name + ' is already added to the list';
        return;
      }

      return true;
    }
  }]);
  return AddEditEnquiryExtra;
}();

exports.default = AddEditEnquiryExtra;


// WEBPACK FOOTER //
// ./client/app/common/services/addEditEnquiryExtraService.js